import PropTypes from 'prop-types';
import CssClassMixin from '../../../mixins/css_class_mixin.jsx';
import InputComponentMixin from '../../../mixins/input/input_component_mixin.jsx';
import CheckboxComponentMixin from '../../../mixins/input/checkbox_component_mixin.jsx';

var createClass = require('create-react-class');

window.InputCheckbox = createClass({
  mixins: [
    CssClassMixin,
    InputComponentMixin,
    CheckboxComponentMixin
  ],

  propTypes: {
    renderAsIndeterminate: PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      themeClassKey: 'input.checkbox'
    };
  },

  render: function() {
    return (
      <input {...this.props}
        checked={this.state.checked}
        className={this.inputClassName()}
        onChange={this._handleCheckboxChange}
        type="checkbox"
        ref="input"
      />
    );
  }

});
